var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('error-pages-form',{attrs:{"id":0},on:{"submit":_vm.addErrorPage,"close":_vm.onClose}})}
var staticRenderFns = []

export { render, staticRenderFns }